export default class TimeController {
  constructor(game) {
    this.game = game;
    this.timePrev = 0;
    this.timeStep = 0;
    this.timeStart = 0;
    this.timeTotal = 0;
    this.active = false;
    this.game.onPause.add(this.handleGamePaused, this);
    this.game.onResume.add(this.handleGameResumed, this);
    this.reset();
  }

  handleGamePaused() {
    if (this.active) {
      this.timePaused = this.game.time.now;
    }
  }

  handleGameResumed() {
    if (this.active) {
      this.timePrev += this.game.time.now - this.timePaused;
    }
  }

  reset() {
    this.timePrev = this.game.time.now;
    this.timeStep = 0;
    this.timeTotal = 0;
    this.active = false;
  }

  start() {
    this.reset();
    this.active = true;
    this.timeStart = this.game.time.now;
  }

  stop() {
    this.active = false;
  }

  update() {
    if (this.active === false) {
      return 0;
    } else {
      this.timeStep = this.game.time.now - this.timePrev;
      this.timePrev = this.game.time.now;
      this.timeTotal += this.timeStep;
      return this.timeStep;
    }
  }

  // CLEAN UP
  destroy() {
    this.game.onPause.remove(this.handleGamePaused, this);
    this.game.onResume.remove(this.handleGameResumed, this);
    this.game = null;
    this.timePrev = null;
    this.timeStep = null;
    this.timeStart = null;
    this.timeTotal = null;
    this.active = false;
  }
}
